import * as React from 'react';
import * as styles from './styles.css';
import { Label } from '../../../../components/Label';
import { Typography } from '../../../../components/Typography';
import { Link } from '../../../../components/Link';
import { ArrowLeft24 } from '../../../../components/Icons';
import { useDeviceType } from '@cian/ui-kit';
import cn from 'clsx';

interface IVacancyTitleProps {
  labels?: string[];
  title?: string;
  header: React.ReactNode;
}

export const VacancyHeader: React.FC<IVacancyTitleProps> = ({ title, labels, header }) => {
  const deviceType = useDeviceType();
  const isDesktop = useDeviceType() === 'desktop';

  return (
    <div className={styles['container']}>
      {header}
      <div className={cn(styles['description'], styles[deviceType])}>
        <div className={cn(styles['control'], styles[deviceType])}>
          <Link
            text="К списку вакансий"
            href={'/vacancies/'}
            color="white"
            beforeIcon={<ArrowLeft24 color="currentColor" />}
          />
        </div>
        {labels && (
          <ul className={cn(styles['label-list'], styles[deviceType])}>
            {labels.map(label => (
              <li className={styles['label-wrapper']} key={label}>
                <Label text={label} color="currentColor" isDarkTheme />
              </li>
            ))}
          </ul>
        )}
        <div className={styles['title']}>
          <Typography.Title level={isDesktop ? 2 : 6} color="currentColor">
            {title}
          </Typography.Title>
        </div>
      </div>
    </div>
  );
};
